<template>
  <b-row>
    <b-col cols="12" class="mb-3">
      <div class="e-create-rate__title">What is your rate:</div>
    </b-col>
    <b-col cols="12" class="mb-4">
      <ul class="e-evaluation">
        <li v-for="i in 10" :key="i" class="e-evaluation__item" @click="onChangeEval(i)" :class="{'active': i === getCriterionEvaluation(criterionId)}">
          <span>{{ i }}</span>
        </li>
      </ul>
    </b-col>
    <b-col cols="12" class="mb-3">
      <div class="e-create-rate__title">Justification:</div>
    </b-col>
    <b-col cols="9">
      <b-form-textarea v-model="justification"
                       class="h-100 mh-100"
                       placeholder="Write something about you rate"
                       :rows="5"
                       :max-rows="8">
      </b-form-textarea>
      <!--<markdown-editor v-model="justification" ref="markdownEditor" :configs="mdConfig"></markdown-editor>-->
    </b-col>
    <b-col cols="3">
      <em-asset-average-score :score="averageEvaluation.toFixed(1)" class="my-0">Your average score so far:</em-asset-average-score>
    </b-col>
  </b-row>
</template>

<script>
  import _ from 'lodash';
  // Temporarily disabled during legacy build migration.
  // import markdownEditor from 'vue-simplemde/src/markdown-editor'
  import {mapGetters, mapActions} from 'vuex';

	export default {
		name: "em-rate-evaluation",
    // components: {
    //   markdownEditor,
    // },
    props: {
      criterionId: String,
    },
    computed: {
      ...mapGetters('rate', {
        getCriterionEvaluation: 'getCriterionEvaluation',
        getCriterionJustification: 'getCriterionJustification',
        averageEvaluation: 'getAverageEvaluation',
      }),
      justification: {
        get() {
          return this.getCriterionJustification(this.criterionId);
        },
        set(value) {
          this.changeJustification({
            id: this.criterionId,
            justification: value,
          })
        }
      },
    },
    data() {
		  return {
		    mdConfig: {
          toolbar: [
            "bold", "italic", "heading",
            "|", "heading-1", "heading-2", "heading-3",
            "|", "quote", "code",
            "|", "unordered-list", "ordered-list", "table",
            "|", "preview"
          ],
        }
      }
    },
    methods: {
      ...mapActions('rate', {
        changeEvaluation: 'changeEvaluation',
        changeJustification: 'changeJustification',
      }),
      onChangeEval(evaluation) {
        this.changeEvaluation({
          id: this.criterionId,
          evaluation,
        })
      },
    }
	}
</script>

<style scoped>
  /* Temporarily disabled during legacy build migration. */
  /* @import '~simplemde/dist/simplemde.min.css'; */
</style>



// WEBPACK FOOTER //
// src/components/modals/rate/evaluation.vue